import { render, staticRenderFns } from "./IconeAtaProrrogacao.vue?vue&type=template&id=15bdac76"
import script from "./IconeAtaProrrogacao.vue?vue&type=script&lang=js"
export * from "./IconeAtaProrrogacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports